import * as React from 'react';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { useSelector, useDispatch } from "react-redux";
import { actions } from 'store/Reducer/actions';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function Toaster() {
  const dispatch = useDispatch();
  const state = useSelector((state) => state.common?.toast);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    dispatch(actions.hideToast());
  };

  React.useEffect(()=>{
  if(state.open){
    setTimeout(() => {
      dispatch(actions.hideToast());
    }, 6000);
  }
  },[state.open, dispatch])

  return (
    <Stack spacing={2} sx={{ width: '100%' }}>
      <Snackbar open={state.open} autoHideDuration={6000} onClose={handleClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
        <Alert onClose={handleClose} severity={state.severity} sx={{ width: '100%' }}>
          <div dangerouslySetInnerHTML={{ __html: state.message }} /> 
        </Alert>
      </Snackbar>
    </Stack>
  );
}